/**
 * Single source of truth for client-side route paths (react-router, SEO canonical paths, redirects).
 */
const WORKY_WEB_APP_PATHS = {
  home: '/',
  landingPageLegacy: '/landing-page',
  splashPageLegacy: '/splashpage',
  landingPageBlog: '/landing-page-blog',
  landingPageBlogPost: '/landing-page-blog/:slug',
  landingPageCompare: '/landing-page-compare',
  landingPageCompareCompetitor: '/landing-page-compare/:competitorSlug',
  landingPageCareers: '/landing-page-careers',
  landingPageProducts: '/landing-page-products',
  landingPageResources: '/landing-page-resources',
  landingPageSales: '/landing-page-sales',
  landingPageOperations: '/landing-page-operations',
  /** Google SEO–optimized single page for healthcare staffing operations software. */
  landingPageOperationsSeo: '/healthcare-staffing-software',
  landingPageMarketplace: '/landing-page-marketplace',
  /** Direct-to-family private home care (LandingHomecareV2). */
  landingPageHomecare: '/landing-page-homecare',
  /** Same LandingHomecareV2 page as landingPageHomecare. */
  homecare: '/homecare',
  careersLegacy: '/careers',
  productsLegacy: '/products',
  resourcesLegacy: '/resources',
  deleteMyData: '/delete-my-data',
  privacy: '/privacy',
  eula: '/EULA',
  /** Standalone Contact Sales / hot-intake form (replaces the landing-page modal). */
  contactSales: '/contact-sales',
  /** Post-submit destination for sales hot-intake forms (Google Ads lead conversion). */
  leadSuccess: '/lead-success',
  homepage: '/homepage',
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  authMfa: '/auth/mfa',
  authNewPassword: '/auth/new-password',
  operationsHomepage: '/operations-homepage',
  inventoryPurchaseIngress: '/inventory-purchase/ingress',
  inventoryPurchaseDetails: '/inventory-purchase/details',
  agencyCustomActions: '/agency/custom-actions',
  agencyInventoryPurchaseDetails: '/agency/inventory-purchase/details',
  agencyNavTest: '/agency-nav-test',
  newShift: '/new-shift',
  myShifts: '/my-shifts',
  account: '/account',
  agencyWorkforce: '/agency/workforce',
  agencyWorkforceNotices: '/agency/workforce-notices',
  agencyAttributes: '/agency/attributes',
  agencyCareProfileAttributes: '/agency/care-profile-attributes',
  agencyTasks: '/agency/tasks',
  agencyWorkerComplianceReporting: '/agency/trust-vault/worker-compliance-reporting',
  agencyWorkerComplianceReportingDetail: '/agency/trust-vault/worker-compliance-reporting/:fileExpiryReportId',
  agencyWorkyPay: '/agency/worky-pay',
  agencyWorkRelationshipConfig: '/agency/work-relationship-config',
  workyPayPayrollView: '/worky-pay-payroll-view',
  workyPayAgencyJobber: '/worky-pay-agency-jobber',
  agencyWorkyTimeClock: '/agency/worky-time-clock',
  agencyClientInvoiceDetails: '/agency/client-invoice-details',
  agencyClients: '/agency/clients',
  agencyCatalogItems: '/agency/catalog-items',
  agencyClientInvoices: '/agency/client-invoices',
  directInvoicingOnDemandDetail: '/direct-invoicing-on-demand-detail',
  directInvoicingOnDemandList: '/direct-invoicing-on-demand-list',
  directInvoicing: '/direct-invoicing',
  agencyBillingPayReporting: '/agency/billing-pay-reporting',
  agencyBillingPayReportingShiftRecon: '/agency/shift-recon-reporting',
  agencyBillingPayReportingDetail: '/agency/shift-recon-reporting/:shiftBasedReconReportId',
  agencyBillingPayReportingTimeClock: '/agency/time-clock-reporting',
  agencyBillingPayReportingTimeClockDetail: '/agency/time-clock-reporting/:timeClockShiftReportId',
  agencyBillingPayReportingCanadianPersonalIncomeTax: '/agency/canadian-personal-income-tax-reporting',
  agencyBillingPayReportingCanadianPersonalIncomeTaxDetail: '/agency/canadian-personal-income-tax-reporting/:canadianPersonalIncomeTaxReportId',
  agencyTaxFilingProfile: '/agency/tax-filing-profile',
  agencyBillingPayReportingAgencyUsageMetrics: '/agency/agency-usage-metrics-reporting',
  agencyBillingPayReportingAgencyUsageMetricsDetail: '/agency/agency-usage-metrics-reporting/:agencyUsageMetricsReportId',
  agencyClientInvoiceList: '/agency/client-invoice-list',
  agencySalesHome: '/agency/sales/home',
  agencyLeads: '/agency/leads',
  agencyLeadsDetails: '/agency/leads-details',
  agencyCreateNewContact: '/agency/create-new-contact',
  agencyViewTasks: '/agency/view-tasks',
  agencyAddOrganization: '/agency/add-organization',
  agencyOrganizationDetails: '/agency/organization-details',
  agencyOrgPortalUserDetails: '/agency/org-portal-user-details',
  agencyCreateWorkTaskTemplate: '/agency/create-work-task-template',
  agencyWorkerOnboardingChecklistTemplates: '/agency/worker-onboarding-checklist-templates',
  agencyEditWorkTaskInstance: '/agency/edit-work-task-instance',
  agencyAddWorkers: '/agency/add-workers',
  agencyEndClientUserExperienceManage: '/agency/end-client-user-experience-manage',
  agencyCommunicationConfig: '/agency/communication-config',
  agencyQuickBooksIntegrationCallback: '/agency/integrations/quickbooks/',
  agencyQuickBooksDisconnected: '/agency/integrations/quickbooks/disconnected',
  agencyIntegrations: '/integrations',
  jobberWorkyPay: '/jobber/worky-pay',
  jobberViewsPayStubConfig: '/jobber-views/pay-stub-config',
  jobberTimeClock: '/jobber/time-clock',
  jobberTasks: '/jobber/tasks',
  jobberPendingTasks: '/jobber/pending-tasks',
  jobberTasksPreviouslySubmitted: '/jobber/tasks/previously-submitted',
  jobberTasksMyDocuments: '/jobber/tasks/my-documents',
  jobberTasksSharedClients: '/jobber-tasks-shared-clients',
  jobberTasksSharedClientDetail: '/jobber-tasks-shared-clients/:endClientPrimaryWorkyUserId',
  jobberTasksClientSharedDocuments: '/jobber/tasks/client-shared-documents',
  jobberTasksNotices: '/jobber/tasks/notices',
  jobberTasksNoticeDetail: '/jobber/tasks/notices/:noticeId',
  workyPay: '/worky-pay',
  jobberHomepage: '/jobber-homepage',
  jobberPreviousShifts: '/jobber-previous-shifts',
  jobberAccountSettings: '/jobber-account-settings',
  jobberImportantDocs: '/jobber-important-docs',
  jobberOnboarding: '/jobber-onboarding',
  endClientHome: '/end-client-home',
  endClientMyShifts: '/end-client-my-shifts',
  endClientNewShift: '/end-client-new-shift',
  endClientDocuments: '/end-client-documents',
  testAuth: '/testAuth',
} as const;

type WorkyWebAppPathKey = keyof typeof WORKY_WEB_APP_PATHS;
type WorkyWebAppPath = (typeof WORKY_WEB_APP_PATHS)[WorkyWebAppPathKey];

export type { WorkyWebAppPath, WorkyWebAppPathKey };
export { WORKY_WEB_APP_PATHS };
